export const WITHOUT_VAT = 'WITHOUT_VAT';
